import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  textLink: {
    [theme.breakpoints.down('x-xs')]: {
      whiteSpace: 'nowrap',
    },

    '&.MuiTypography-root a': {
      textDecoration: 'none',
      color: theme.palette.text.primary,

      '&:hover': {
        textDecoration: 'underline',
      },

      '&.active': {
        textDecoration: 'none',
        cursor: 'default',
        color: theme.palette.primary.light,
      },
    },
  },
}));
